import general from './general';
import drawbacks from './drawbacks';
import accts_receivable from './accts_receivable';
import reports from './reports';
import management from './management';
import utilities from './utilities';
import security from './security';
import others from './others';
// ==============================|| UTILITIES MENU ITEMS ||============================== //

const options = {
    id: 'options',
    title: 'Settings',
    type: 'group',
    children: []
};

if (general.children.length > 0) options.children.push(general);
if (drawbacks.children.length > 0) options.children.push(drawbacks);
if (accts_receivable.children.length > 0) options.children.push(accts_receivable);
if (reports.children.length > 0) options.children.push(reports);
if (management.children.length > 0) options.children.push(management);
if (utilities.children.length > 0) options.children.push(utilities);
if (security.children.length > 0) options.children.push(security);
if (others.children.length > 0) options.children.push(others);

export default options;
